import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverDocumentsListService {
  private selectedDriverSubject = new Subject<any | null>();
  private driversSubject = new Subject<any | null>();
  private searchTermSubject = new Subject<string>();
  private refreshListSubject = new Subject<void>();
  private _refreshAlerts = new Subject<number | null>();

  selectedDriver$: Observable<any> = this.selectedDriverSubject.asObservable();
  drivers$: Observable<any> = this.driversSubject.asObservable();
  searchTerm$ = this.searchTermSubject.asObservable();
  refreshList$ = this.refreshListSubject.asObservable();
  refreshAlerts$ = this._refreshAlerts.asObservable();

  constructor() { }

  public updateSelectedDriver(driver:any) {
    this.selectedDriverSubject.next(driver);
  }

  public updateDrivers(drivers:any) {
    this.driversSubject.next(drivers)
  }

  public updateSearchTerm(term: string) {
    this.searchTermSubject.next(term);
  }

  public refreshDriverList() {
    this.refreshListSubject.next();
  }

  public refreshAlerts(driverId: number | null) {
    this._refreshAlerts.next(driverId);
  }
}